import { forwardRef, type Ref, type SVGProps } from "react";
const IconHomeTypeFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="m28.34 7.06-14-5a1 1 0 0 0-.92.12A1 1 0 0 0 13 3v13.35l-2.33-2.09a1 1 0 0 0-1.34 0l-5.82 5.22A1.55 1.55 0 0 0 3 20.62v8.11A1.27 1.27 0 0 0 4.27 30H28a1 1 0 0 0 1-1V8a1 1 0 0 0-.66-.94M12 28H8v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1zm8-5a1 1 0 0 1-2 0V11a1 1 0 0 1 2 0zm4 0a1 1 0 0 1-2 0V13a1 1 0 0 1 2 0z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconHomeTypeFilledSVG);
ForwardRef.displayName = "IconHomeTypeFilled";
export { ForwardRef as IconHomeTypeFilled };
